import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { saveOnboarding } from '../store/slices/authSlice';

const ROLES = [
  {
    id: 'developer',
    title: 'Developer',
    desc: 'Building with the API',
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M6 7l-4 3 4 3M14 7l4 3-4 3M11 5l-2 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    id: 'business',
    title: 'Business',
    desc: 'Managing team access',
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <rect x="2" y="7" width="16" height="11" rx="2" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M7 7V5a3 3 0 0 1 6 0v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M10 12v2M7 12h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    id: 'explorer',
    title: 'Exploring',
    desc: 'Seeing what\'s possible',
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M13 7l-3.5 2-1 3.5 3.5-2 1-3.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
        <circle cx="10" cy="10" r="1" fill="currentColor"/>
      </svg>
    ),
  },
];

export default function OnboardingModal() {
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [role, setRole] = useState(null);
  const [biz, setBiz] = useState({ name: '', email: '', region: 'lagos', usecase: 'safety' });

  const handleRoleNext = () => {
    if (!role) return;
    if (role === 'business') { setStep(2); return; }
    dispatch(saveOnboarding({ userType: role }));
  };

  const handleBizDone = (e) => {
    e.preventDefault();
    dispatch(saveOnboarding({ userType: 'business', businessName: biz.name, businessEmail: biz.email, region: biz.region, usecase: biz.usecase }));
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-head">
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: 'var(--accent)', letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: 8 }}>
            {step === 1 ? '01 / WELCOME' : '02 / BUSINESS INFO'}
          </div>
          <div className="modal-title">
            {step === 1 ? 'Welcome to Cybernate.' : 'Tell us about your business.'}
          </div>
          <p className="modal-sub">
            {step === 1
              ? 'How will you use the platform? We\'ll set things up accordingly.'
              : 'Just a few details to personalise your experience.'}
          </p>
        </div>

        {step === 1 && (
          <>
            <div className="modal-body">
              <div className="role-grid">
                {ROLES.map(r => (
                  <button
                    key={r.id}
                    className={`role-card${role === r.id ? ' selected' : ''}`}
                    onClick={() => setRole(r.id)}
                  >
                    <div className="role-card-icon">{r.icon}</div>
                    <div className="role-card-title">{r.title}</div>
                    <div className="role-card-desc">{r.desc}</div>
                  </button>
                ))}
              </div>
            </div>
            <div className="modal-foot">
              <button className="btn btn-ghost" onClick={() => dispatch(saveOnboarding({ userType: 'individual' }))}>
                Skip for now
              </button>
              <button className="btn btn-primary" onClick={handleRoleNext} disabled={!role}>
                {role === 'business' ? 'Continue →' : 'Get started →'}
              </button>
            </div>
          </>
        )}

        {step === 2 && (
          <form onSubmit={handleBizDone}>
            <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
              <div className="field">
                <label>Business name</label>
                <input type="text" required placeholder="Acme Technologies"
                  value={biz.name} onChange={e => setBiz({ ...biz, name: e.target.value })} />
              </div>
              <div className="field">
                <label>Business email <span style={{ color: 'var(--fg-dim)', fontFamily: 'var(--font-mono)', fontSize: 9, letterSpacing: '0.06em' }}>OPTIONAL</span></label>
                <input type="email" placeholder="team@acme.com"
                  value={biz.email} onChange={e => setBiz({ ...biz, email: e.target.value })} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                <div className="field">
                  <label>Region</label>
                  <select value={biz.region} onChange={e => setBiz({ ...biz, region: e.target.value })}>
                    <option value="lagos">Lagos · LAG-01</option>
                    <option value="nairobi">Nairobi · NBO-02</option>
                    <option value="johannesburg">Joburg · JNB-01</option>
                    <option value="accra">Accra · ACC-01 (Q3)</option>
                  </select>
                </div>
                <div className="field">
                  <label>Primary use case</label>
                  <select value={biz.usecase} onChange={e => setBiz({ ...biz, usecase: e.target.value })}>
                    <option value="safety">Safety / Civic</option>
                    <option value="fintech">Fintech / Payments</option>
                    <option value="energy">Energy / Grid</option>
                    <option value="agriculture">Agriculture</option>
                    <option value="health">Health</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-foot">
              <button type="button" className="btn btn-ghost" onClick={() => setStep(1)}>← Back</button>
              <button type="submit" className="btn btn-primary">Finish setup →</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
